import axiosInstance from "../axiosInstance";

export const getTirthAll = async ({ filters, page, limit }) => {
  const params = { pageNo: page };
  if (limit) params.pageSize = limit;

  if (filters?.states?.length) params.states = filters?.states?.join(",");

  if (filters?.districts?.length)
    params.districts = filters?.districts?.join(",");
  if (filters?.countries?.length)
    params.countries = filters?.countries?.join(",");
  if (filters?.search) params.search = filters.search;
  if (filters?.featured) params.featured = filters.featured;

  const res = await axiosInstance.get("/tirths", { params });

  if (res?.code === 200 && res?.data?.tirths) {
    return {
      success: res.code,
      data: {
        list: res.data.tirths || [],
        total: res.meta.total || 0,
      },
      message: res.message,
    };
  } else {
    return {
      success: false,
      data: { list: [], total: 0 },
      message: res?.message || "Something went wrong",
    };
  }
};

export const getTirthStates = async () => {
  const res = await axiosInstance.get("states");

  if (res?.code === 200 && res?.data?.states) {
    const data = res.data.states.map((state) => ({
      value: state._id || state,
      label: state?.name ? state?.name : state,
      isLang: true,
      imageUrl: state?.image,
      districts: state.districts.map((district) => ({
        value: district?._id,
        label: district?.name,
        isLang: true,
        imageUrl: district?.image,
      })),
    }));
    return { success: true, data };
  }
  return { success: false, data: [] };
};
